import { ExamsFilterRouteView } from "@features/exam";
import { DialogWrapper } from "@memorang/ui";
/* -----------------UI--------------- */
import { Dialog as PaperDialog } from "react-native-paper";

type Props = {
	visible: boolean;
	handleClose?: () => void;
};
export const ExamsFilterDialog = ({ visible, handleClose }: Props) => {
	return (
		<DialogWrapper
			visible={visible}
			handleClose={handleClose}
			showCloseButton={false}
		>
			<PaperDialog.Content
				style={{
					flex: 1,
					paddingBottom: 0,
					paddingHorizontal: 0,
					marginTop: 0,
				}}
			>
				<ExamsFilterRouteView handleClose={handleClose} searchIcon="magnify" />
			</PaperDialog.Content>
		</DialogWrapper>
	);
};
